import type { ClerkAPIResponseError, ClerkV6Error } from '@/features/auth/shared/types/clerk';

const isClerkV6Error = (error: unknown): error is ClerkV6Error =>
  error !== null && typeof error === 'object' && 'code' in error && typeof (error as ClerkV6Error).code === 'string';

const isClerkAPIResponseError = (error: unknown): error is ClerkAPIResponseError =>
  error !== null &&
  typeof error === 'object' &&
  'errors' in error &&
  Array.isArray((error as ClerkAPIResponseError).errors);

export const extractClerkErrorMessage = (error: unknown): string | undefined => {
  if (isClerkV6Error(error)) {
    return error.longMessage ?? error.message;
  }
  if (isClerkAPIResponseError(error)) {
    return error.errors?.[0]?.message ?? error.errors?.[0]?.longMessage;
  }
  return undefined;
};

export const extractClerkErrorCode = (error: unknown): string | undefined => {
  if (isClerkAPIResponseError(error) && error.errors?.[0]?.code) {
    return error.errors[0].code;
  }
  if (isClerkV6Error(error)) {
    return error.code;
  }
  return undefined;
};
